export default __webpack_public_path__ + "static/media/fb.4aeb301d.svg";